import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { filterSecondaryCarrierOptions } from "@/features/insurance/helpers/filter-secondary-options";
import type { InsuranceListOptions, InsuranceListResponse } from "@/features/insurance/types";
import { mapCarriersToOptions } from "@/features/insurance/helpers/map-to-options";

import { getInsuranceList } from "../queryFunctions/getInsuranceList";
import { insuranceListKeys } from "../keyFactory";

type UseMappedInsuranceListOptions = {
  isEnabled?: boolean;
  isSecondary?: boolean;
};

export function useMappedInsuranceList(
  options: UseMappedInsuranceListOptions = {},
): UseQueryResult<InsuranceListOptions> {
  const { isEnabled: enabled = true, isSecondary = false } = options;

  return useQuery({
    enabled,
    queryFn: getInsuranceList,
    queryKey: insuranceListKeys.all(),
    refetchOnWindowFocus: false,
    select: (data: InsuranceListResponse): InsuranceListOptions => {
      const mapped = mapCarriersToOptions(data);

      return {
        carrierOptions: isSecondary
          ? filterSecondaryCarrierOptions(mapped.carrierOptions)
          : mapped.carrierOptions,
        stateOptions: mapped.stateOptions,
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - reference data changes infrequently
  });
}
